// Tiny imperative redirect utility. Renders nothing; navigates on mount.
// Used for legacy URL aliases (/paste → /new etc) and for redirecting
// signed-in users away from `/`.

import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";

export function RedirectTo({ to, paramName }: { to: string; paramName?: string }) {
  const navigate = useNavigate();
  const params = useParams();
  useEffect(() => {
    let target = to;
    if (paramName && params[paramName]) {
      target = `${to}/${params[paramName]}`;
    }
    navigate(target, { replace: true });
  }, [navigate, to, paramName, params]);
  return null;
}
